import { Link } from "react-router-dom";
import { Home, ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { Btn, Overline } from "@/components/Btn";

export default function NotFound() {
  return (
    <>
      <Seo title="Page introuvable (404) | Ronalp Enseigne" description="La page recherchée n'existe pas." path="/404" noindex />
      <section className="mx-auto max-w-3xl px-4 py-32 text-center">
        <Overline className="justify-center">Erreur 404</Overline>
        <h1 className="mt-6 text-6xl sm:text-8xl font-extrabold chrome-text">404</h1>
        <p className="mt-6 text-lg text-slate-300">La page que vous cherchez est introuvable ou a été déplacée.</p>
        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
          <Btn to="/" size="lg"><Home className="h-4 w-4" /> Retour à l'accueil</Btn>
          <Btn to="/contact/" variant="outline" size="lg">Nous contacter <ArrowRight className="h-4 w-4" /></Btn>
        </div>
      </section>
    </>
  );
}
